import React from "react";
import { getTranslatedStatus } from "../hooks/statusTranslate";

// status badge 
export const StatusBadge = ({ status, getClass }) => {
  return (
    <span className={`badge ${getClass?.(status)}`}>
      {getTranslatedStatus(status)}
    </span>
  );
};

// status text 
export const StatusText = ({ status }) => {
  return (
    <span className={``}>
      {getTranslatedStatus(status)}
    </span>
  );
};


